export function sliceExcerpt($) {
    var targets = ['.promo-card .excerpt', '.article-card .excerpt'];

    targets.forEach(target => {
        $(target).each(function () {

            var maxLength = 200;
            var strippedContent = $(this).text();

            if (strippedContent.length > maxLength) {
                var truncated = strippedContent.slice(0, maxLength) + '...';
                $(this).html(truncated);
            }
        });
    });
}